import { Routes } from '@angular/router';
export const CANDIDATES_POOL_ROUTES: Routes = [
  {
    data: {
      icon: 'groups',
      module: 'CANDIDATE',
    },
    path: 'candidates',
    title: 'Candidate Pool',
    loadComponent: () => import('./candidates-pool.component').then((e) => e.CandidatesPoolComponent),

    children: [
      {
        path: 'add-candidates',
        title: 'Add candidates to pool',
        loadComponent: () =>
          import('../candidates/add-candidates/add-candidates.component')
            .then((m) => m.AddCandidatesComponent),
      },

      {
        path: 'candidate/:id',
        title: 'Candidate Pool Details',
        loadComponent: () =>
          import('./candidate-pool-details/candidate-pool-details.component')
            .then((m) => m.CandidatePoolDetailsComponent),
      },

      {
        path: '',
        pathMatch: 'full',
        data: {
          reuse: true,
        },
        loadComponent: () =>
          import('./candidate-pool-list/candidate-pool-list.component').then(m => m.CandidatePoolListComponent)
      },
    ]
  },
];